import React, { Fragment } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { bool } from "prop-types";
import { useDispatch } from "react-redux";
import gaEventTracker, { events } from "util/gaEventTracker";
import Notification from "pages/_components/Notification";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import { push } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col, Row } from "react-bootstrap";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";

const StepStart = ({ isMobile }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const onHeaderBack = () => {
        history.push("/");
    };

    const onStart = () => {
        gaEventTracker.triggerEvent(events.registry12);
        dispatch(push("/environment/stepGeneralData"));
    };

    return (
        <Fragment>
            <Notification scopeToShow="login" />

            {isMobile ? (
                <Head
                    titleText={i18n.get("legalPerson.title", "Registro")}
                    onBack={onHeaderBack}
                    hideNavbarInMobile
                    // tooltipMobile
                    // onClickTooltip={() => setHelpIsVisible(true)}
                    // tooltipImage="images/figma/icon/help.svg"
                    showCenterContent
                />
            ) : (
                <HeaderSimple inverse />
            )}
            <MainContainer className="onboarding step-start">
                {!isMobile && (
                    <Head
                        titleText={i18n.get("legalPerson.title", "Registro")}
                        onBack={onHeaderBack}
                        showCenterContent
                    />
                )}
                {isMobile && (
                    <h1 className="text-center">
                        <CustomText text={i18n.get("", "Antes de comenzar...")} />
                    </h1>
                )}
                {!isMobile && (
                    <h2>
                        <CustomText text={i18n.get("", "Antes de comenzar...")} />
                    </h2>
                )}
                <CustomText
                    text={i18n.get(
                        "",
                        "Tené en cuenta que en algunos pasos vamos a pedirte documentación legal de tu empresa, original o autenticada por el escribano.",
                    )}
                />
                <div className="box box-shadow three-step-box">
                    <div className="paso1">
                        <div>
                            <b>
                                <CustomText text={i18n.get("", "Paso 1:")} />
                                <br />
                                <CustomText text={i18n.get("", "Datos de empresa:")} />
                            </b>
                            <br />
                            <CustomText text={i18n.get("", "Datos generales")} />
                            <br />
                            <CustomText text={i18n.get("", "Datos impositivos")} />
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso2">
                        <div>
                            <b>
                                <CustomText text={i18n.get("", "Paso 2:")} />
                                <br />
                                <CustomText text={i18n.get("", "Estructura societaria:")} />
                            </b>
                            <br />
                            <CustomText text={i18n.get("", "Representante Legal")} />
                            <br />
                            <CustomText text={i18n.get("", "Socios")} />
                            <br />
                            <CustomText text={i18n.get("", "Apoderados")} />
                            <br />
                            <CustomText text={i18n.get("", "Beneficiarios Finales")} />
                        </div>
                    </div>

                    <hr className="dotted" />
                    <div className="paso3">
                        <div>
                            <b>
                                <CustomText text={i18n.get("", "Paso 3:")} />
                                <br />
                                <CustomText text={i18n.get("", "Carga de documentación")} />
                            </b>
                        </div>
                    </div>
                </div>
                <Row className="form-actions no-print">
                    <Col xs={12} md={4} mdOffset={4}>
                        <Button bsStyle="primary" label="global.continue" loading={false} onClick={onStart} block />
                    </Col>
                </Row>
            </MainContainer>
        </Fragment>
    );
};

StepStart.propTypes = {
    isMobile: bool.isRequired,
};

export default withRouter(StepStart);
